class LuxuryTestimonials extends HTMLElement {
  connectedCallback() {
    this.slides = [...this.querySelectorAll('[data-luxury-slide]')];
    this.dots = [...this.querySelectorAll('[data-luxury-dot]')];
    if (!this.slides.length) return;

    this.dots.forEach((dot, index) => {
      dot.addEventListener('click', () => this.show(index));
      dot.addEventListener('keydown', (event) => this.onKeydown(event, index));
    });

    this.show(0);
    const delay = Number(this.dataset.autoplay || 0);
    if (delay > 0 && this.slides.length > 1 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      this.timer = window.setInterval(() => this.show((this.current + 1) % this.slides.length), delay);
      this.addEventListener('mouseenter', () => window.clearInterval(this.timer), { once: true });
    }
  }

  disconnectedCallback() {
    window.clearInterval(this.timer);
  }

  show(index) {
    this.current = index;
    this.slides.forEach((slide, slideIndex) => {
      const active = slideIndex === index;
      slide.hidden = !active;
      slide.setAttribute('aria-hidden', String(!active));
    });
    this.dots.forEach((dot, dotIndex) => {
      const active = dotIndex === index;
      dot.setAttribute('aria-current', active ? 'true' : 'false');
      dot.tabIndex = active ? 0 : -1;
    });
  }

  onKeydown(event, index) {
    if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
    event.preventDefault();
    let next = index;
    if (event.key === 'ArrowLeft') next = (index - 1 + this.dots.length) % this.dots.length;
    if (event.key === 'ArrowRight') next = (index + 1) % this.dots.length;
    if (event.key === 'Home') next = 0;
    if (event.key === 'End') next = this.dots.length - 1;
    this.show(next);
    this.dots[next].focus();
  }
}

if (!customElements.get('luxury-testimonials')) {
  customElements.define('luxury-testimonials', LuxuryTestimonials);
}
